import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import Sales from "./Sales";
import SalesView from "./view/SalesView";
import SalesDashboard from "./view/dashboard/SalesDashboard";
import LotsList from "./view/lots/LotsList";
import BiddersList from "./view/bidders/BiddersList";
import Notes from "./view/notes/Notes";
import Terms from "./view/terms/Terms";
import ActivitiesView from "./view/activities/ActivitiesView";
import InvoicesList from "./view/invoices/InvoicesList";
import SettlementsList from "./view/settlements/SettlementsList";
import BatchLotUp from "./batch-lot-up/BatchLotUp";
import BatchCategoryLotUp from "./batch-category-lot-up/BatchCategoryLotUp";
import PreBidsList from "./view/pre-bids/PreBidsList";
import BidsList from "@/modules/sales/view/bids/BidsList";
import TelephoneBids from "@/modules/sales/view/telephone-bids/TelephoneBidsList";
import AuctioneerConsole from "@/modules/lots/AuctioneerConsole";
import VendorsList from "@/modules/sales/view/vendors/VendorsList";
import SepaList from "./view/sepa/SepaList.vue";
import Attachments from "@/modules/sales/view/attachments/Attachments";
import ConditionReportRequests from "@/modules/sales/view/condition-report-requests/ConditionReportRequests";
import Dpv from "./view/dpv/Dpv";
import CollectionAppointments from "./view/collection-appointments/CollectionAppointments";
import BatchLotUpV2 from "@/modules/sales/batch-lot-up-v2/BatchLotUpV2";

const routes = [
  {
    path: 'sales',
    name: 'sales',
    component: Sales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'sales/:sale_no/batch-lot-up',
    name: 'sale-batch-lot-up',
    component: BatchLotUp,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'sales/:sale_no/batch-lot-up-v2',
    name: 'sale-batch-lot-up-v2',
    component: BatchLotUpV2,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'sales/:sale_no/batch-category-lot-up',
    name: 'sale-batch-category-lot-up',
    component: BatchCategoryLotUp,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'sales/view/:id',
    component: SalesView,
    name: 'sales.view',
    redirect: 'sales/view/:id/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'sales.dashboard',
        component: SalesDashboard
      },
      {
        path: 'lots',
        name: 'sales.lots',
        component: LotsList
      },
      {
        path: 'bidders',
        name: 'sales.bidders',
        component: BiddersList
      },
      {
        path: 'bids',
        name: 'sales.bids',
        component: BidsList
      },
      /*{
        path: 'telephone-bids',
        name: 'sales.telephone-bids',
        component: TelephoneBids
      },*/
      {
        path: 'pre-bids',
        name: 'sales.pre-bids',
        component: PreBidsList
      },
      {
        path: 'notes',
        name: 'sales.notes',
        component: Notes
      },
      {
        path: 'terms',
        name: 'sales.terms',
        component: Terms
      },
      {
        path: 'condition-report-requests',
        name: 'sales.condition-report-requests',
        component: ConditionReportRequests
      },
      {
        path: 'invoices',
        name: 'sales.invoices',
        component: InvoicesList
      },
      {
        path: 'settlements',
        name: 'sales.settlements',
        component: SettlementsList
      },
      {
        path: 'sepa',
        name: 'sales.sepa',
        component: SepaList
      },
      {
        path: 'attachments',
        name: 'sales.attachments',
        component: Attachments
      },
      {
        path: 'vendors',
        name: 'sales.vendors',
        component: VendorsList
      },
      {
        path: 'activities',
        name: 'sales.activities',
        component: ActivitiesView
      },
      {
        path: 'dpv',
        name: 'sales.dpv',
        component: Dpv
      },
      {
        path: 'collection-appointments',
        name: 'sales.collection-appointments',
        component: CollectionAppointments
      },
    ]
  },
  {
    path: 'auctioneer-console/sale/:saleNo',
    name: 'auctioneerConsole',
    component: AuctioneerConsole,
    meta: {
      requiresAuth: true
    },
  },
];

MenuService.addMenuItem(new MenuItem('/sales', i18n.t('Sales'), 4, 'server', [], 'view_auction'));

export {routes}
